/* eslint-disable @typescript-eslint/no-floating-promises */
/* istanbul ignore file */

import Logger from "@next/core-logger"
import React from "react"
import {hydrateRoot} from "react-dom/client"
import {Provider} from "react-redux"
import {createEmotionCache} from "@next/emotion-cache"
import {CacheProvider} from "@emotion/react"
import inialiseGlobalEvents from "../events/initialiseGlobalEvents"
import subscribeRedirectToAlternativeLangeuage from "../utils/redirectToAlternativeLanguage"
import App from "../App"
import {getProps, getStore} from "./utils"
import {TP_PAGE_IDENTIFIER} from "../config/constants"
import "./polyfill"

declare const window: any

const {store, newState} = getStore()
const appProps = getProps()
const cache = createEmotionCache({key: "header", namespace: true, rtl: appProps.textAlignment === "rtl"})
const hydrate = () => {
    Logger.debug(`Hydrating Header`)
    const rootElement = document.getElementById("next-header-entrypoint")
    if (!rootElement) {
        throw new Error("Header root element not found")
    }
    window.requestIdleCallback(() =>
        hydrateRoot(
            rootElement,
            <Provider store={store} serverState={newState}>
                <CacheProvider value={cache}>
                    <App {...appProps} />
                </CacheProvider>
            </Provider>,
        ),
    )
}

function doHydrate() {
    hydrate()
    // Todo: Remove this try-catch in User Story 390229
    // https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/390229
    try {
        window.NextBasket.SubscribeToEvents()
    } catch {
        console.log("TODO: Tech Debt - 390229 - Temp fix for INC1350177", "Please Ignore Subscribe Errors")
    } finally {
        window.removeEventListener("hydrate-chunks-header", doHydrate)
    }
}

inialiseGlobalEvents()
window.addEventListener("hydrate-chunks-header", doHydrate)
subscribeRedirectToAlternativeLangeuage()

const isEPMTPPage = window.document.querySelector(`${TP_PAGE_IDENTIFIER}`)

if (isEPMTPPage || window.platmodflags?.googleAnalytics) {
    if (window.GoogleAnalyticsNext !== undefined) {
        window.GoogleAnalyticsNext.Init(appProps.siteUrl)
    }
}

if (isEPMTPPage || window.platmodflags?.monetateEvents) {
    if (window.MonetateShoppingBagSDK !== undefined) {
        window.MonetateShoppingBagSDK.InitialiseEvents()
    }
}
